var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Common',[_c('template',{slot:"cd"},[_c('CdhospitalExamination')],1),_c('template',{slot:"sz"},[_c('SzhospitalExamination')],1),_c('template',{slot:"hf"},[_c('HfhospitalExamination')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }